// frontend/src/components/pantallaInformativa/RelojPantalla.js
import React, { useEffect, useState } from 'react';

/**
 * Hora y fecha grandes debajo del video. Tiene su propio intervalo para que el tic de cada segundo
 * vuelva a dibujar solo el reloj y no el iframe del video.
 *
 * Con variante="encabezado" va chico, en blanco, en la franja de arriba (modo Solo turnero).
 */
function RelojPantalla({ variante }) {
    const [ahora, setAhora] = useState(() => new Date());

    useEffect(() => {
        const intervalo = setInterval(() => setAhora(new Date()), 1000);
        return () => clearInterval(intervalo);
    }, []);

    const hora = ahora.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', hour12: false });
    const fecha = ahora
        .toLocaleDateString('es-AR', { weekday: 'long', day: 'numeric', month: 'long' })
        .replace(',', '');

    return (
        <div className={`pi-reloj${variante === 'encabezado' ? ' pi-reloj--encabezado' : ''}`}>
            <span className="pi-reloj__hora">{hora}</span>
            <span className="pi-reloj__separador" aria-hidden="true" />
            <span className="pi-reloj__fecha">{fecha.charAt(0).toUpperCase() + fecha.slice(1)}</span>
        </div>
    );
}

export default RelojPantalla;
